export const InactiveMobileHeader = () => {
  return (
    <div className="xl:hidden">
      <div style={{ display: "block", boxSizing: "border-box" }}>
        <div
          style={{
            boxSizing: "border-box",
            WebkitBoxAlign: "center",
            alignItems: "center",
            backgroundColor: "rgb(12, 19, 31)",
            display: "flex",
            height: "48px",
            WebkitBoxPack: "justify",
            justifyContent: "space-between",
            padding: "0px 16px",
            position: "relative",
            zIndex: 1202,
          }}
        >
          <a
            aria-label="Retour à l'accueil SNCF Connect"
            href="/"
            style={{
              boxSizing: "border-box",
              backgroundColor: "rgba(0, 0, 0, 0)",
              margin: "0px",
              fontSize: "13px",
              lineHeight: "18px",
              fontWeight: 700,
              color: "rgb(141, 232, 254)",
              textDecoration: "none solid rgb(141, 232, 254)",
              cursor: "pointer",
              position: "relative",
              display: "flex",
              WebkitBoxAlign: "center",
              alignItems: "center",
              WebkitBoxPack: "center",
              justifyContent: "center",
              height: "48px",
            }}
          >
            <svg
              aria-hidden="true"
              viewBox="0 0 130 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ boxSizing: "border-box", height: "48px" }}
            >
              <path
                d="M33.593 11.955H10.276C4.594 11.955 0 16.575 0 22.255a10.268 10.268 0 0 0 10.276 10.276h23.317A10.268 10.268 0 0 0 43.87 22.256c0-5.682-4.595-10.3-10.276-10.3ZM4.57 42.288c-.89 0-1.804.321-1.804 1.21 0 .865.865 1.063 2.421 1.433 1.655.395 3.607 1.136 3.607 3.36 0 2.717-2.224 3.73-4.669 3.73-1.235 0-2.643-.347-3.507-1.014-.494-.37-.618-.79-.618-1.111 0-.642.494-1.186 1.16-1.186.297 0 .594.1.964.37.643.52 1.359.791 2.15.791.814 0 1.827-.32 1.827-1.334 0-.938-.89-1.185-2.593-1.58-1.655-.396-3.31-1.063-3.31-3.187 0-2.495 2.223-3.557 4.446-3.557 1.111 0 2.297.272 3.087.865.544.395.667.765.667 1.087 0 .617-.444 1.136-1.136 1.136-.247 0-.519-.099-.815-.321-.593-.494-1.21-.692-1.877-.692Zm6.644-.519c0-1.26.914-1.457 1.334-1.457.42 0 1.334.198 1.334 1.457v.544h.05c.493-1.112 1.827-2.125 3.457-2.125 2.915 0 4.126 2.224 4.126 4.52v5.633c0 1.333-.94 1.556-1.409 1.556-.469 0-1.407-.223-1.407-1.556v-4.842c0-1.334-.297-2.989-2.1-2.989-1.779 0-2.618 1.532-2.618 3.039v4.792c0 1.333-.939 1.556-1.408 1.556-.47 0-1.408-.223-1.408-1.556v-8.572h.05Zm21.44 7.09c.717 0 1.137.543 1.137 1.111 0 .395-.124.79-.741 1.235-.79.568-2.026.815-2.989.815-3.335 0-5.953-2.198-5.953-5.903 0-3.631 2.692-5.904 5.978-5.904 1.062 0 2.149.247 2.94.79.641.445.79.89.79 1.211 0 .617-.47 1.21-1.21 1.21-.248 0-.52-.074-.94-.37a2.678 2.678 0 0 0-1.58-.519c-2.05 0-3.063 1.828-3.063 3.582 0 1.754.988 3.557 3.063 3.557.617 0 1.16-.149 1.655-.47.37-.247.667-.346.914-.346Zm4.1-6.102c-1.061 0-1.259-.74-1.259-1.111 0-.37.198-1.112 1.26-1.112h1.062V38.88c0-2.667 1.038-5.063 4.273-5.063 1.161 0 1.779.395 1.779 1.235 0 .617-.42 1.136-1.31 1.136-1.506 0-1.95.963-1.95 2.52v1.827h1.53c1.063 0 1.26.741 1.26 1.112 0 .37-.197 1.111-1.26 1.111h-1.53v7.584c0 1.333-.94 1.556-1.409 1.556-.444 0-1.408-.223-1.408-1.556v-7.584h-1.037Z"
                fill="#8DE8FE"
                style={{ boxSizing: "border-box" }}
              ></path>
              <path
                d="M56.121 11.955a10.268 10.268 0 0 0-10.275 10.276A10.268 10.268 0 0 0 56.12 32.507 10.268 10.268 0 0 0 66.397 22.23 10.268 10.268 0 0 0 56.12 11.955ZM54.392 48.858c.716 0 1.136.544 1.136 1.112 0 .395-.124.79-.741 1.235-.79.568-2.026.815-2.99.815-3.334 0-5.977-2.198-5.977-5.928 0-3.631 2.717-5.928 6.003-5.928 1.062 0 2.149.246 2.939.79.642.445.79.89.79 1.21 0 .618-.469 1.21-1.21 1.21-.247 0-.519-.073-.938-.37a2.678 2.678 0 0 0-1.581-.519c-2.05 0-3.088 1.853-3.088 3.582 0 1.754.988 3.557 3.088 3.557.617 0 1.16-.148 1.655-.47.37-.172.666-.296.913-.296Zm8.768 3.187c-3.384 0-6.076-2.446-6.076-5.978 0-3.532 2.717-5.879 6.076-5.879 3.384 0 6.077 2.347 6.077 5.879 0 3.508-2.693 5.978-6.077 5.978Zm0-9.584c-2.223 0-3.235 1.852-3.235 3.581 0 1.754 1.037 3.631 3.235 3.631 2.223 0 3.236-1.877 3.236-3.63 0-1.73-1.037-3.582-3.236-3.582Zm8.473-.692c0-1.26.914-1.482 1.334-1.482.42 0 1.333.198 1.333 1.482v.544h.05c.494-1.112 1.828-2.125 3.483-2.125 2.914 0 4.125 2.248 4.125 4.52v5.657c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-4.841c0-1.334-.297-2.99-2.1-2.99-1.778 0-2.618 1.532-2.618 3.039v4.817c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-8.62h.025Zm13.091 0c0-1.26.914-1.482 1.334-1.482.42 0 1.334.198 1.334 1.482v.544h.05c.493-1.112 1.827-2.125 3.482-2.125 2.915 0 4.125 2.248 4.125 4.52v5.657c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-4.841c0-1.334-.296-2.99-2.1-2.99-1.778 0-2.618 1.532-2.618 3.039v4.817c0 1.334-.938 1.556-1.407 1.556-.47 0-1.409-.222-1.409-1.556v-8.62h.025Zm15.414 5.237c.123 1.58 1.556 2.742 3.186 2.742 1.161 0 1.877-.371 2.569-.964.395-.321.642-.395.963-.395.618 0 1.112.444 1.112 1.111 0 .223-.099.643-.47 1.013-1.086 1.038-2.346 1.507-4.149 1.507-3.459 0-6.027-2.223-6.027-5.854 0-3.606 2.544-6.002 5.928-6.002 2.717 0 4.891 1.531 5.335 4.816.025.223.05.395.05.593 0 .988-.544 1.408-1.458 1.408h-7.039v.025Zm5.73-2.026c0-1.457-.815-2.717-2.643-2.717-1.655 0-2.989 1.136-3.112 2.717h5.755Zm13.092 3.878c.716 0 1.136.544 1.136 1.112 0 .395-.124.79-.741 1.235-.791.568-2.026.815-2.989.815-3.335 0-5.978-2.198-5.978-5.928 0-3.631 2.718-5.928 6.003-5.928 1.062 0 2.149.246 2.939.79.642.445.791.89.791 1.21 0 .618-.47 1.21-1.211 1.21-.247 0-.518-.073-.938-.37a2.68 2.68 0 0 0-1.581-.519c-2.05 0-3.088 1.853-3.088 3.582 0 1.754.988 3.557 3.088 3.557.617 0 1.161-.148 1.655-.47.37-.172.667-.296.914-.296Zm8.25 3.088c-2.964 0-3.607-1.828-3.607-3.977v-5.237h-.914c-1.062 0-1.259-.74-1.259-1.111 0-.37.197-1.112 1.259-1.112h.914v-1.926c0-1.285.914-1.507 1.384-1.507.469 0 1.383.222 1.383 1.507v1.926h1.754c1.062 0 1.259.741 1.259 1.112 0 .37-.197 1.111-1.259 1.111h-1.754v5.212c0 1.087.37 1.68 1.062 1.68.124 0 .272-.025.445-.05.197-.024.222-.024.321-.024.691 0 1.062.519 1.062 1.037 0 .445-.247.815-.667 1.038a3.085 3.085 0 0 1-1.383.32Z"
                fill="#fff"
                style={{ boxSizing: "border-box" }}
              ></path>
              <path
                d="M39.868 25.592a7.484 7.484 0 1 0-13.388-6.694 7.484 7.484 0 0 0 13.388 6.694Z"
                fill="#0C131F"
                style={{ boxSizing: "border-box" }}
              ></path>
            </svg>
          </a>
        </div>
      </div>
      <header
        role="banner"
        tabIndex={-1}
        style={{ boxSizing: "border-box", color: "rgb(243, 243, 244)" }}
      >
        <div style={{ display: "block", boxSizing: "border-box" }}>
          <nav
            role="navigation"
            aria-label="Menu principal"
            data-test="tabBar-header"
            style={{
              zIndex: 1202,
              boxSizing: "border-box",
              backgroundColor: "rgb(12, 19, 31)",
              bottom: "0px",
              height: "58px",
              left: "0px",
              position: "fixed",
              right: "0px",
            }}
          >
            <ul
              style={{
                boxSizing: "border-box",
                listStyle: "outside none none",
                margin: "0px",
                padding: "0px",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(2rem, 1fr))",
                WebkitBoxPack: "center",
                justifyContent: "center",
                height: "58px",
                width: "100%",
              }}
            >
              <li style={{ boxSizing: "border-box" }}>
                <button
                  tabIndex={0}
                  type="button"
                  aria-label="Menu Voyager"
                  aria-controls="tabBar-panelContent-0"
                  aria-expanded="false"
                  style={{
                    boxSizing: "border-box",
                    appearance: "button",
                    textTransform: "none",
                    overflow: "visible",
                    fontFamily: "Avenir",
                    fontSize: "14px",
                    lineHeight: "24.5px",
                    margin: "0px",
                    display: "inline-flex",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    outline: "rgb(243, 243, 244) none 0px",
                    border: "0px none rgb(243, 243, 244)",
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    textDecoration: "none solid rgb(243, 243, 244)",
                    fontWeight: 700,
                    minWidth: "64px",
                    borderRadius: "14px",
                    transition:
                      "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    color: "rgb(243, 243, 244)",
                    padding: "0px",
                    height: "58px",
                    width: "100%",
                    whiteSpace: "pre",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      height: "58px",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        height: "24px",
                        width: "1.5rem",
                        fill: "rgb(243, 243, 244)",
                        flexShrink: 0,
                        margin: "8px 0px 4px",
                      }}
                    >
                      <path
                        d="M19 15C18.2925 15.0019 17.6083 15.2538 17.0685 15.7113C16.5287 16.1688 16.168 16.8023 16.05 17.5H7.65003C6.84156 17.5297 6.0431 17.3135 5.36003 16.88C5.09371 16.6953 4.87628 16.4485 4.72647 16.1611C4.57665 15.8737 4.49895 15.5541 4.50003 15.23C4.4716 14.8369 4.53649 14.4427 4.68943 14.0795C4.84236 13.7163 5.079 13.3944 5.38003 13.14C6.04631 12.6841 6.84373 12.4593 7.65003 12.5H16C16.8515 12.4777 17.6728 12.1794 18.34 11.65C18.7372 11.2878 19.0477 10.8409 19.2485 10.3423C19.4493 9.84373 19.5353 9.30634 19.5 8.77001C19.5114 8.2984 19.4113 7.83077 19.208 7.40508C19.0048 6.97938 18.7039 6.60763 18.33 6.32001C17.55 5.76186 16.6089 5.47392 15.65 5.50001H8.00003C7.87466 4.75831 7.47523 4.09077 6.8809 3.62968C6.28656 3.1686 5.5407 2.94761 4.79111 3.01051C4.04153 3.07342 3.34293 3.41563 2.83375 3.96932C2.32458 4.52301 2.04199 5.24779 2.04199 6.00001C2.04199 6.75223 2.32458 7.477 2.83375 8.03069C3.34293 8.58438 4.04153 8.92659 4.79111 8.9895C5.5407 9.0524 6.28656 8.83142 6.8809 8.37033C7.47523 7.90924 7.87466 7.2417 8.00003 6.50001H15.7C16.4353 6.4694 17.16 6.68398 17.76 7.11001C18.0149 7.30336 18.2196 7.55501 18.3571 7.84386C18.4945 8.1327 18.5607 8.4503 18.55 8.77001C18.5817 9.15843 18.5253 9.54899 18.3851 9.91259C18.2448 10.2762 18.0243 10.6035 17.74 10.87C17.1688 11.3098 16.4602 11.533 15.74 11.5H7.74003C6.70744 11.4538 5.68938 11.7568 4.85003 12.36C4.41249 12.6961 4.06166 13.132 3.82681 13.6312C3.59197 14.1305 3.47993 14.6786 3.50003 15.23C3.49277 15.714 3.60594 16.1922 3.82937 16.6216C4.05281 17.0511 4.37949 17.4182 4.78003 17.69C5.63042 18.2492 6.63277 18.5321 7.65003 18.5H16.05C16.1454 19.0643 16.4002 19.5896 16.7844 20.0138C17.1686 20.438 17.6661 20.7435 18.2182 20.8941C18.7703 21.0448 19.354 21.0344 19.9004 20.8642C20.4468 20.694 20.9331 20.371 21.302 19.9334C21.6708 19.4958 21.9068 18.9618 21.982 18.3945C22.0573 17.8272 21.9687 17.2501 21.7267 16.7315C21.4847 16.2129 21.0994 15.7743 20.6163 15.4675C20.1331 15.1607 19.5723 14.9985 19 15ZM19 20C18.6045 20 18.2178 19.8827 17.8889 19.6629C17.56 19.4432 17.3036 19.1308 17.1523 18.7654C17.0009 18.3999 16.9613 17.9978 17.0385 17.6098C17.1156 17.2219 17.3061 16.8655 17.5858 16.5858C17.8655 16.3061 18.2219 16.1156 18.6099 16.0384C18.9978 15.9613 19.3999 16.0009 19.7654 16.1522C20.1309 16.3036 20.4432 16.56 20.663 16.8889C20.8827 17.2178 21 17.6044 21 18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0392 19.7893 19.5305 20 19 20Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        height: "22px",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          maxWidth: "96px",
                          fontSize: "11px",
                          lineHeight: "14px",
                          fontWeight: 700,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Voyager
                      </span>
                    </span>
                  </div>
                </button>
              </li>
              <li style={{ boxSizing: "border-box" }}>
                <button
                  tabIndex={0}
                  type="button"
                  aria-label="Menu Billets"
                  aria-controls="tabBar-panelContent-1"
                  aria-expanded="false"
                  style={{
                    boxSizing: "border-box",
                    appearance: "button",
                    textTransform: "none",
                    overflow: "visible",
                    fontFamily: "Avenir",
                    fontSize: "14px",
                    lineHeight: "24.5px",
                    margin: "0px",
                    display: "inline-flex",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    outline: "rgb(243, 243, 244) none 0px",
                    border: "0px none rgb(243, 243, 244)",
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    textDecoration: "none solid rgb(243, 243, 244)",
                    fontWeight: 700,
                    minWidth: "64px",
                    borderRadius: "14px",
                    transition:
                      "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    color: "rgb(243, 243, 244)",
                    padding: "0px",
                    height: "58px",
                    width: "100%",
                    whiteSpace: "pre",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      height: "58px",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        height: "24px",
                        width: "1.5rem",
                        fill: "rgb(243, 243, 244)",
                        flexShrink: 0,
                        margin: "8px 0px 4px",
                      }}
                    >
                      <path
                        d="M18 6H16V8H18V6Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M13 3V11H21V3H13ZM20 10H14V4H20V10Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M8 16H6V18H8V16Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M3 21H11V13H3V21ZM4 14H10V20H4V14Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M18 16H16V18H18V16Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M5 9H3V11H5V9Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M11 3H9V5H11V3Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M8 6H6V8H8V6Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M5 3H3V5H5V3Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M11 9H9V11H11V9Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M15 13H13V15H15V13Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M21 13H19V15H21V13Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M15 19H13V21H15V19Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        height: "22px",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          maxWidth: "96px",
                          fontSize: "11px",
                          lineHeight: "14px",
                          fontWeight: 700,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Billets
                      </span>
                    </span>
                  </div>
                </button>
              </li>
              <li style={{ boxSizing: "border-box" }}>
                <button
                  tabIndex={0}
                  type="button"
                  aria-label="Menu Billets"
                  aria-controls="tabBar-panelContent-1"
                  aria-expanded="false"
                  style={{
                    boxSizing: "border-box",
                    appearance: "button",
                    textTransform: "none",
                    overflow: "visible",
                    fontFamily: "Avenir",
                    fontSize: "14px",
                    lineHeight: "24.5px",
                    margin: "0px",
                    display: "inline-flex",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    outline: "rgb(243, 243, 244) none 0px",
                    border: "0px none rgb(243, 243, 244)",
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    textDecoration: "none solid rgb(243, 243, 244)",
                    fontWeight: 700,
                    minWidth: "64px",
                    borderRadius: "14px",
                    transition:
                      "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    color: "rgb(243, 243, 244)",
                    padding: "0px",
                    height: "58px",
                    width: "100%",
                    whiteSpace: "pre",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      height: "58px",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        height: "24px",
                        width: "1.5rem",
                        fill: "rgb(243, 243, 244)",
                        flexShrink: 0,
                        margin: "8px 0px 4px",
                      }}
                    >
                      <path d="M9 6.34003H5.47C5.25778 6.3602 5.06116 6.46029 4.92 6.62003C4.77342 6.76958 4.69132 6.97063 4.69132 7.18003C4.69132 7.38944 4.77342 7.59049 4.92 7.74003C5.0671 7.88861 5.26182 7.98066 5.47 8.00003H9C9.21318 7.97344 9.41082 7.87462 9.56 7.72003C9.70201 7.56814 9.781 7.36797 9.781 7.16003C9.781 6.9521 9.70201 6.75193 9.56 6.60003C9.41034 6.44932 9.21171 6.3571 9 6.34003Z"></path>
                      <path d="M9 9.69003H5.47C5.25333 9.71792 5.05605 9.82911 4.92 10C4.77342 10.1496 4.69132 10.3506 4.69132 10.56C4.69132 10.7694 4.77342 10.9705 4.92 11.12C5.06116 11.2798 5.25778 11.3799 5.47 11.4H9C9.21442 11.3776 9.41341 11.2781 9.56 11.12C9.6967 10.9631 9.76862 10.7601 9.7612 10.5521C9.75377 10.3442 9.66754 10.1468 9.52 10C9.38822 9.83911 9.20423 9.72943 9 9.69003Z"></path>
                      <path d="M5.47 13C5.29834 12.9992 5.13064 13.0516 4.99 13.15C4.84528 13.2374 4.73027 13.3663 4.66 13.52C4.5936 13.6744 4.57622 13.8454 4.6102 14.0099C4.64418 14.1745 4.72789 14.3246 4.85 14.44C4.97916 14.5673 5.14374 14.6525 5.32217 14.6846C5.50061 14.7168 5.68458 14.6942 5.85 14.62C6.00968 14.5608 6.14631 14.4522 6.24 14.31C6.33813 14.1768 6.39073 14.0155 6.39 13.85C6.39074 13.7374 6.36801 13.6259 6.32324 13.5226C6.27847 13.4193 6.21266 13.3265 6.13 13.25C6.04356 13.1646 5.94017 13.0982 5.82649 13.0551C5.71281 13.012 5.59137 12.9933 5.47 13Z"></path>
                      <path d="M9 13H8.09C7.97125 12.9755 7.84875 12.9755 7.73 13C7.6146 13.0385 7.50644 13.0959 7.41 13.17C7.32043 13.2509 7.24888 13.3497 7.2 13.46C7.14893 13.5662 7.12162 13.6822 7.12 13.8C7.12027 13.918 7.14764 14.0343 7.2 14.14C7.24888 14.2504 7.32043 14.3492 7.41 14.43C7.5014 14.5117 7.61119 14.57 7.73 14.6C7.84875 14.6246 7.97125 14.6246 8.09 14.6H9C9.21442 14.5776 9.41341 14.4781 9.56 14.32C9.70201 14.1681 9.781 13.968 9.781 13.76C9.781 13.5521 9.70201 13.3519 9.56 13.2C9.39989 13.0745 9.20339 13.0043 9 13Z"></path>
                      <path d="M18.58 13H15.09C14.8768 13.0266 14.6792 13.1255 14.53 13.28C14.388 13.4319 14.309 13.6321 14.309 13.84C14.309 14.048 14.388 14.2481 14.53 14.4C14.6766 14.5581 14.8756 14.6576 15.09 14.68H18.58C18.7922 14.6599 18.9888 14.5598 19.13 14.4C19.2766 14.2505 19.3587 14.0494 19.3587 13.84C19.3587 13.6306 19.2766 13.4296 19.13 13.28C18.9859 13.1241 18.7909 13.0248 18.58 13Z"></path>
                      <path d="M15.09 8.00003C15.2633 8.00099 15.4333 7.95242 15.58 7.86003C15.7312 7.77871 15.8531 7.65196 15.9285 7.49767C16.0038 7.34337 16.0289 7.16931 16 7.00003C15.9631 6.83416 15.8778 6.68294 15.755 6.56548C15.6322 6.44801 15.4774 6.36956 15.31 6.34003C15.1436 6.29028 14.9664 6.29028 14.8 6.34003C14.6403 6.39922 14.5037 6.50782 14.41 6.65003C14.3113 6.78623 14.2619 6.95201 14.27 7.12003C14.2699 7.23012 14.292 7.3391 14.335 7.44046C14.3779 7.54183 14.4409 7.63351 14.52 7.71003C14.6657 7.87638 14.8698 7.98023 15.09 8.00003Z"></path>
                      <path d="M15.09 9.69003C14.8756 9.71246 14.6766 9.81196 14.53 9.97003C14.388 10.1219 14.309 10.3221 14.309 10.53C14.309 10.738 14.388 10.9381 14.53 11.09C14.6766 11.2481 14.8756 11.3476 15.09 11.37H16C16.2144 11.3476 16.4134 11.2481 16.56 11.09C16.702 10.9381 16.781 10.738 16.781 10.53C16.781 10.3221 16.702 10.1219 16.56 9.97003C16.4134 9.81196 16.2144 9.71246 16 9.69003H15.09Z"></path>
                      <path d="M17 7.81003C17.0889 7.88934 17.1903 7.95353 17.3 8.00003C17.4187 8.02513 17.5413 8.02513 17.66 8.00003H18.53C18.7409 7.97529 18.9359 7.87598 19.08 7.72003C19.2266 7.57049 19.3087 7.36944 19.3087 7.16003C19.3087 6.95063 19.2266 6.74958 19.08 6.60003C18.9388 6.44029 18.7422 6.3402 18.53 6.32003H17.66C17.5413 6.29494 17.4187 6.29494 17.3 6.32003C17.1812 6.35007 17.0714 6.4084 16.98 6.49003C16.8904 6.5709 16.8189 6.6697 16.77 6.78003C16.7176 6.88574 16.6903 7.00207 16.69 7.12003C16.6916 7.23784 16.7189 7.35387 16.77 7.46003C16.8167 7.59387 16.8957 7.7141 17 7.81003Z"></path>
                      <path d="M18.53 9.69003C18.3567 9.68908 18.1867 9.73765 18.04 9.83003C17.8924 9.91845 17.7769 10.0515 17.71 10.21C17.6386 10.3631 17.621 10.5357 17.66 10.7C17.6915 10.8655 17.7757 11.0164 17.9 11.13C18.0232 11.2506 18.1802 11.3308 18.35 11.36C18.5164 11.4098 18.6936 11.4098 18.86 11.36C19.0251 11.2847 19.1618 11.1586 19.25 11C19.3398 10.8596 19.3883 10.6967 19.39 10.53C19.3912 10.4198 19.3697 10.3104 19.3267 10.2089C19.2836 10.1074 19.2201 10.0158 19.14 9.94003C19.0598 9.86029 18.9646 9.79716 18.8599 9.75426C18.7552 9.71136 18.6431 9.68954 18.53 9.69003Z"></path>
                      <path d="M21.41 3.57003C21.0334 3.20177 20.5267 2.99695 20 3.00003H15.6C14.8585 2.99906 14.1301 3.19582 13.49 3.57003C12.8612 3.94104 12.3459 4.47707 12 5.12003C11.6541 4.47707 11.1388 3.94104 10.51 3.57003C9.86986 3.19582 9.1415 2.99906 8.4 3.00003H4C3.47328 2.99695 2.9666 3.20177 2.59 3.57003C2.40339 3.74606 2.25478 3.95841 2.15331 4.19402C2.05185 4.42962 1.99967 4.68351 2 4.94003V17C2.00141 17.2563 2.05437 17.5096 2.15573 17.745C2.25709 17.9804 2.40478 18.1929 2.59 18.37C2.97775 18.7147 3.48129 18.9004 4 18.89H7.62C8.47516 18.8961 9.30714 19.1688 10 19.67L10.65 20.14L11.24 20.71C11.3369 20.8013 11.4485 20.8757 11.57 20.93C11.8216 21.0235 12.0984 21.0235 12.35 20.93C12.4715 20.8757 12.5831 20.8013 12.68 20.71L13.27 20.14L13.93 19.67C14.6339 19.1608 15.4812 18.8877 16.35 18.89H20C20.5276 18.8921 21.0358 18.6917 21.42 18.33C21.7808 17.9803 21.9891 17.5024 22 17V5.00003C22.0087 4.73346 21.9606 4.46809 21.8589 4.22154C21.7572 3.97499 21.6042 3.7529 21.41 3.57003ZM11.41 19.46L10.62 18.89C9.74962 18.2503 8.70013 17.9005 7.62 17.89H4C3.73562 17.8942 3.48034 17.7936 3.29 17.61C3.1211 17.4497 3.01776 17.2323 3 17V5.00003C2.99851 4.87129 3.02348 4.74362 3.07336 4.62493C3.12325 4.50623 3.19699 4.39905 3.29 4.31003C3.38178 4.21373 3.49185 4.13671 3.61376 4.08348C3.73568 4.03025 3.86699 4.00188 4 4.00003H8.4C9.1968 3.99393 9.96455 4.29888 10.54 4.85003C10.8202 5.11306 11.0437 5.43058 11.1967 5.78311C11.3498 6.13563 11.4292 6.51572 11.43 6.90003L11.41 19.46ZM21 17C21.0001 17.1271 20.9745 17.2529 20.9247 17.3697C20.8748 17.4866 20.8018 17.5922 20.71 17.68C20.5197 17.8636 20.2644 17.9642 20 17.96H16.4C15.3199 17.9705 14.2704 18.3203 13.4 18.96L12.6 19.53V6.87003C12.6076 6.49417 12.6902 6.12362 12.843 5.78015C12.9959 5.43669 13.2158 5.12725 13.49 4.87003C14.0548 4.31878 14.8108 4.00707 15.6 4.00003H20C20.2644 3.99583 20.5197 4.09651 20.71 4.28003C20.803 4.36905 20.8768 4.47623 20.9266 4.59493C20.9765 4.71362 21.0015 4.84129 21 4.97003V17Z"></path>
                    </svg>
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        height: "22px",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          maxWidth: "96px",
                          fontSize: "11px",
                          lineHeight: "14px",
                          fontWeight: 700,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Offres
                      </span>
                    </span>
                  </div>
                </button>
              </li>
              <li style={{ boxSizing: "border-box" }}>
                <button
                  tabIndex={0}
                  type="button"
                  aria-label="Menu Compte"
                  aria-controls="tabBar-panelContent-3"
                  aria-expanded="false"
                  style={{
                    boxSizing: "border-box",
                    appearance: "button",
                    textTransform: "none",
                    overflow: "visible",
                    fontFamily: "Avenir",
                    fontSize: "14px",
                    lineHeight: "24.5px",
                    margin: "0px",
                    display: "inline-flex",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    outline: "rgb(243, 243, 244) none 0px",
                    border: "0px none rgb(243, 243, 244)",
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    textDecoration: "none solid rgb(243, 243, 244)",
                    fontWeight: 700,
                    minWidth: "64px",
                    borderRadius: "14px",
                    transition:
                      "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    color: "rgb(243, 243, 244)",
                    padding: "0px",
                    height: "58px",
                    width: "100%",
                    whiteSpace: "pre",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      height: "58px",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        height: "24px",
                        width: "1.5rem",
                        fill: "rgb(243, 243, 244)",
                        flexShrink: 0,
                        margin: "8px 0px 4px",
                      }}
                    >
                      <path
                        d="M14.2507 10.0988C14.9317 9.65003 15.4628 9.00399 15.7743 8.24522C16.0859 7.48646 16.1634 6.65033 15.9968 5.84629C15.8476 5.03646 15.4591 4.29126 14.8826 3.70878C14.3061 3.12629 13.5686 2.73381 12.7671 2.58299C11.9711 2.41824 11.1444 2.49999 10.3952 2.81754C9.86342 3.0379 9.38334 3.36855 8.98599 3.78813C8.58863 4.2077 8.28284 4.70685 8.08837 5.25332C7.89391 5.79978 7.81511 6.3814 7.85706 6.96056C7.89901 7.53973 8.06078 8.10355 8.33191 8.61559C8.60304 9.12763 8.9775 9.57648 9.43109 9.93313C9.88467 10.2898 10.4073 10.5463 10.9651 10.6861C11.523 10.8259 12.1036 10.8458 12.6696 10.7447C13.2356 10.6435 13.7742 10.4235 14.2507 10.0988ZM13.6956 4.05147C14.2053 4.39619 14.6022 4.88597 14.8361 5.45877C15.1178 6.15045 15.1443 6.92136 14.9107 7.63109C14.6771 8.34082 14.1989 8.94216 13.5633 9.32559C12.9277 9.70903 12.177 9.84904 11.4478 9.72014C10.7186 9.59123 10.0594 9.20198 9.59045 8.62329C9.12146 8.04459 8.87378 7.31494 8.89254 6.56722C8.9113 5.81951 9.19524 5.10347 9.69264 4.54953C10.1901 3.99558 10.8678 3.64057 11.6026 3.54915C12.3373 3.45774 13.0801 3.636 13.6956 4.05147Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M7.39753 15.1161C8.30094 14.1869 9.45816 13.551 10.7212 13.2899C11.9842 13.0287 13.2956 13.1542 14.4877 13.6502C15.6798 14.1462 16.6983 14.9902 17.413 16.0743C18.1278 17.1583 18.5062 18.4332 18.4999 19.7357V20.9901C18.4973 21.1245 18.4433 21.2527 18.3493 21.3477C18.2552 21.4428 18.1283 21.4974 17.9953 21.5C17.8622 21.4974 17.7354 21.4428 17.6413 21.3477C17.5472 21.2527 17.4932 21.1245 17.4906 20.9901V19.7357C17.4906 18.2644 16.9121 16.8534 15.8824 15.813C14.8528 14.7726 13.4562 14.1881 12 14.1881C10.5438 14.1881 9.14721 14.7726 8.11751 15.813C7.08782 16.8534 6.50934 18.2644 6.50934 19.7357V20.9901C6.50676 21.1245 6.45276 21.2527 6.35867 21.3477C6.26459 21.4428 6.13772 21.4974 6.00469 21.5C5.9385 21.5008 5.87288 21.4876 5.81204 21.4612C5.7512 21.4349 5.69649 21.396 5.65143 21.347C5.60295 21.3015 5.56443 21.2462 5.53836 21.1847C5.51228 21.1233 5.49923 21.0569 5.50004 20.9901V19.7357C5.5014 18.0026 6.18392 16.341 7.39753 15.1161Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        height: "22px",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          maxWidth: "96px",
                          fontSize: "11px",
                          lineHeight: "14px",
                          fontWeight: 700,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Compte
                      </span>
                    </span>
                  </div>
                </button>
              </li>
            </ul>
            <div
              style={{
                boxSizing: "border-box",
                backgroundColor: "rgb(141, 232, 254)",
                borderTopLeftRadius: "48px",
                borderTopRightRadius: "48px",
                bottom: "0px",
                content: '""',
                height: "2px",
                position: "absolute",
                width: "100%",
                left: "0px",
                opacity: 0,
                pointerEvents: "none",
              }}
            ></div>
          </nav>
        </div>
        <div style={{ display: "none", boxSizing: "border-box" }}>
          <div
            style={{
              boxSizing: "border-box",
              backgroundColor: "rgb(12, 19, 31)",
              height: "64px",
              minWidth: "100%",
              position: "absolute",
              zIndex: 1201,
            }}
          ></div>
          <div
            data-test="navBar-header"
            style={{
              zIndex: 1202,
              boxSizing: "border-box",
              backgroundColor: "rgb(12, 19, 31)",
              bottom: "0px",
              height: "58px",
              left: "0px",
              position: "fixed",
              right: "0px",
            }}
          >
            <div
              style={{
                boxSizing: "border-box",
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
                display: "block",
                paddingLeft: "16px",
                paddingRight: "16px",
              }}
            >
              <div
                style={{
                  boxSizing: "border-box",
                  display: "grid",
                  gridTemplateColumns: "1fr auto 1fr",
                  height: "100%",
                }}
              >
                <a
                  aria-label="Retour à l'accueil SNCF Connect"
                  href="/app"
                  style={{
                    boxSizing: "border-box",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    margin: "0px",
                    fontSize: "13px",
                    lineHeight: "18px",
                    fontWeight: 700,
                    color: "rgb(141, 232, 254)",
                    textDecoration: "none solid rgb(141, 232, 254)",
                    cursor: "pointer",
                    position: "relative",
                    display: "flex",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    width: "fit-content",
                  }}
                >
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 130 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ boxSizing: "border-box", height: "48px" }}
                  >
                    <path
                      d="M33.593 11.955H10.276C4.594 11.955 0 16.575 0 22.255a10.268 10.268 0 0 0 10.276 10.276h23.317A10.268 10.268 0 0 0 43.87 22.256c0-5.682-4.595-10.3-10.276-10.3ZM4.57 42.288c-.89 0-1.804.321-1.804 1.21 0 .865.865 1.063 2.421 1.433 1.655.395 3.607 1.136 3.607 3.36 0 2.717-2.224 3.73-4.669 3.73-1.235 0-2.643-.347-3.507-1.014-.494-.37-.618-.79-.618-1.111 0-.642.494-1.186 1.16-1.186.297 0 .594.1.964.37.643.52 1.359.791 2.15.791.814 0 1.827-.32 1.827-1.334 0-.938-.89-1.185-2.593-1.58-1.655-.396-3.31-1.063-3.31-3.187 0-2.495 2.223-3.557 4.446-3.557 1.111 0 2.297.272 3.087.865.544.395.667.765.667 1.087 0 .617-.444 1.136-1.136 1.136-.247 0-.519-.099-.815-.321-.593-.494-1.21-.692-1.877-.692Zm6.644-.519c0-1.26.914-1.457 1.334-1.457.42 0 1.334.198 1.334 1.457v.544h.05c.493-1.112 1.827-2.125 3.457-2.125 2.915 0 4.126 2.224 4.126 4.52v5.633c0 1.333-.94 1.556-1.409 1.556-.469 0-1.407-.223-1.407-1.556v-4.842c0-1.334-.297-2.989-2.1-2.989-1.779 0-2.618 1.532-2.618 3.039v4.792c0 1.333-.939 1.556-1.408 1.556-.47 0-1.408-.223-1.408-1.556v-8.572h.05Zm21.44 7.09c.717 0 1.137.543 1.137 1.111 0 .395-.124.79-.741 1.235-.79.568-2.026.815-2.989.815-3.335 0-5.953-2.198-5.953-5.903 0-3.631 2.692-5.904 5.978-5.904 1.062 0 2.149.247 2.94.79.641.445.79.89.79 1.211 0 .617-.47 1.21-1.21 1.21-.248 0-.52-.074-.94-.37a2.678 2.678 0 0 0-1.58-.519c-2.05 0-3.063 1.828-3.063 3.582 0 1.754.988 3.557 3.063 3.557.617 0 1.16-.149 1.655-.47.37-.247.667-.346.914-.346Zm4.1-6.102c-1.061 0-1.259-.74-1.259-1.111 0-.37.198-1.112 1.26-1.112h1.062V38.88c0-2.667 1.038-5.063 4.273-5.063 1.161 0 1.779.395 1.779 1.235 0 .617-.42 1.136-1.31 1.136-1.506 0-1.95.963-1.95 2.52v1.827h1.53c1.063 0 1.26.741 1.26 1.112 0 .37-.197 1.111-1.26 1.111h-1.53v7.584c0 1.333-.94 1.556-1.409 1.556-.444 0-1.408-.223-1.408-1.556v-7.584h-1.037Z"
                      fill="#8DE8FE"
                      style={{ boxSizing: "border-box" }}
                    ></path>
                    <path
                      d="M56.121 11.955a10.268 10.268 0 0 0-10.275 10.276A10.268 10.268 0 0 0 56.12 32.507 10.268 10.268 0 0 0 66.397 22.23 10.268 10.268 0 0 0 56.12 11.955ZM54.392 48.858c.716 0 1.136.544 1.136 1.112 0 .395-.124.79-.741 1.235-.79.568-2.026.815-2.99.815-3.334 0-5.977-2.198-5.977-5.928 0-3.631 2.717-5.928 6.003-5.928 1.062 0 2.149.246 2.939.79.642.445.79.89.79 1.21 0 .618-.469 1.21-1.21 1.21-.247 0-.519-.073-.938-.37a2.678 2.678 0 0 0-1.581-.519c-2.05 0-3.088 1.853-3.088 3.582 0 1.754.988 3.557 3.088 3.557.617 0 1.16-.148 1.655-.47.37-.172.666-.296.913-.296Zm8.768 3.187c-3.384 0-6.076-2.446-6.076-5.978 0-3.532 2.717-5.879 6.076-5.879 3.384 0 6.077 2.347 6.077 5.879 0 3.508-2.693 5.978-6.077 5.978Zm0-9.584c-2.223 0-3.235 1.852-3.235 3.581 0 1.754 1.037 3.631 3.235 3.631 2.223 0 3.236-1.877 3.236-3.63 0-1.73-1.037-3.582-3.236-3.582Zm8.473-.692c0-1.26.914-1.482 1.334-1.482.42 0 1.333.198 1.333 1.482v.544h.05c.494-1.112 1.828-2.125 3.483-2.125 2.914 0 4.125 2.248 4.125 4.52v5.657c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-4.841c0-1.334-.297-2.99-2.1-2.99-1.778 0-2.618 1.532-2.618 3.039v4.817c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-8.62h.025Zm13.091 0c0-1.26.914-1.482 1.334-1.482.42 0 1.334.198 1.334 1.482v.544h.05c.493-1.112 1.827-2.125 3.482-2.125 2.915 0 4.125 2.248 4.125 4.52v5.657c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-4.841c0-1.334-.296-2.99-2.1-2.99-1.778 0-2.618 1.532-2.618 3.039v4.817c0 1.334-.938 1.556-1.407 1.556-.47 0-1.409-.222-1.409-1.556v-8.62h.025Zm15.414 5.237c.123 1.58 1.556 2.742 3.186 2.742 1.161 0 1.877-.371 2.569-.964.395-.321.642-.395.963-.395.618 0 1.112.444 1.112 1.111 0 .223-.099.643-.47 1.013-1.086 1.038-2.346 1.507-4.149 1.507-3.459 0-6.027-2.223-6.027-5.854 0-3.606 2.544-6.002 5.928-6.002 2.717 0 4.891 1.531 5.335 4.816.025.223.05.395.05.593 0 .988-.544 1.408-1.458 1.408h-7.039v.025Zm5.73-2.026c0-1.457-.815-2.717-2.643-2.717-1.655 0-2.989 1.136-3.112 2.717h5.755Zm13.092 3.878c.716 0 1.136.544 1.136 1.112 0 .395-.124.79-.741 1.235-.791.568-2.026.815-2.989.815-3.335 0-5.978-2.198-5.978-5.928 0-3.631 2.718-5.928 6.003-5.928 1.062 0 2.149.246 2.939.79.642.445.791.89.791 1.21 0 .618-.47 1.21-1.211 1.21-.247 0-.518-.073-.938-.37a2.68 2.68 0 0 0-1.581-.519c-2.05 0-3.088 1.853-3.088 3.582 0 1.754.988 3.557 3.088 3.557.617 0 1.161-.148 1.655-.47.37-.172.667-.296.914-.296Zm8.25 3.088c-2.964 0-3.607-1.828-3.607-3.977v-5.237h-.914c-1.062 0-1.259-.74-1.259-1.111 0-.37.197-1.112 1.259-1.112h.914v-1.926c0-1.285.914-1.507 1.384-1.507.469 0 1.383.222 1.383 1.507v1.926h1.754c1.062 0 1.259.741 1.259 1.112 0 .37-.197 1.111-1.259 1.111h-1.754v5.212c0 1.087.37 1.68 1.062 1.68.124 0 .272-.025.445-.05.197-.024.222-.024.321-.024.691 0 1.062.519 1.062 1.037 0 .445-.247.815-.667 1.038a3.085 3.085 0 0 1-1.383.32Z"
                      fill="#fff"
                      style={{ boxSizing: "border-box" }}
                    ></path>
                    <path
                      d="M39.868 25.592a7.484 7.484 0 1 0-13.388-6.694 7.484 7.484 0 0 0 13.388 6.694Z"
                      fill="#0C131F"
                      style={{ boxSizing: "border-box" }}
                    ></path>
                  </svg>
                </a>
                <nav
                  aria-label="Menu principal"
                  style={{ boxSizing: "border-box" }}
                >
                  <ul
                    style={{
                      boxSizing: "border-box",
                      listStyle: "outside none none",
                      margin: "0px",
                      padding: "0px",
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(2rem, 1fr))",
                      WebkitBoxPack: "center",
                      justifyContent: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <li style={{ boxSizing: "border-box" }}>
                      <div
                        style={{
                          boxSizing: "border-box",
                          height: "100%",
                          position: "relative",
                        }}
                      >
                        <a
                          aria-label="Voyager"
                          href="/"
                          style={{
                            boxSizing: "border-box",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            margin: "0px",
                            fontSize: "13px",
                            lineHeight: "18px",
                            fontWeight: 700,
                            cursor: "pointer",
                            position: "relative",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "inline-flex",
                            boxShadow: "none",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            color: "rgb(243, 243, 244)",
                            padding: "0px",
                            height: "100%",
                            width: "100%",
                            textTransform: "none",
                            whiteSpace: "pre",
                            textDecoration: "none solid rgb(243, 243, 244)",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "24px",
                                width: "1.5rem",
                                fill: "rgb(243, 243, 244)",
                                flexShrink: 0,
                                margin: "8px 0px 4px",
                              }}
                            >
                              <path
                                d="M19 15C18.2925 15.0019 17.6083 15.2538 17.0685 15.7113C16.5287 16.1688 16.168 16.8023 16.05 17.5H7.65003C6.84156 17.5297 6.0431 17.3135 5.36003 16.88C5.09371 16.6953 4.87628 16.4485 4.72647 16.1611C4.57665 15.8737 4.49895 15.5541 4.50003 15.23C4.4716 14.8369 4.53649 14.4427 4.68943 14.0795C4.84236 13.7163 5.079 13.3944 5.38003 13.14C6.04631 12.6841 6.84373 12.4593 7.65003 12.5H16C16.8515 12.4777 17.6728 12.1794 18.34 11.65C18.7372 11.2878 19.0477 10.8409 19.2485 10.3423C19.4493 9.84373 19.5353 9.30634 19.5 8.77001C19.5114 8.2984 19.4113 7.83077 19.208 7.40508C19.0048 6.97938 18.7039 6.60763 18.33 6.32001C17.55 5.76186 16.6089 5.47392 15.65 5.50001H8.00003C7.87466 4.75831 7.47523 4.09077 6.8809 3.62968C6.28656 3.1686 5.5407 2.94761 4.79111 3.01051C4.04153 3.07342 3.34293 3.41563 2.83375 3.96932C2.32458 4.52301 2.04199 5.24779 2.04199 6.00001C2.04199 6.75223 2.32458 7.477 2.83375 8.03069C3.34293 8.58438 4.04153 8.92659 4.79111 8.9895C5.5407 9.0524 6.28656 8.83142 6.8809 8.37033C7.47523 7.90924 7.87466 7.2417 8.00003 6.50001H15.7C16.4353 6.4694 17.16 6.68398 17.76 7.11001C18.0149 7.30336 18.2196 7.55501 18.3571 7.84386C18.4945 8.1327 18.5607 8.4503 18.55 8.77001C18.5817 9.15843 18.5253 9.54899 18.3851 9.91259C18.2448 10.2762 18.0243 10.6035 17.74 10.87C17.1688 11.3098 16.4602 11.533 15.74 11.5H7.74003C6.70744 11.4538 5.68938 11.7568 4.85003 12.36C4.41249 12.6961 4.06166 13.132 3.82681 13.6312C3.59197 14.1305 3.47993 14.6786 3.50003 15.23C3.49277 15.714 3.60594 16.1922 3.82937 16.6216C4.05281 17.0511 4.37949 17.4182 4.78003 17.69C5.63042 18.2492 6.63277 18.5321 7.65003 18.5H16.05C16.1454 19.0643 16.4002 19.5896 16.7844 20.0138C17.1686 20.438 17.6661 20.7435 18.2182 20.8941C18.7703 21.0448 19.354 21.0344 19.9004 20.8642C20.4468 20.694 20.9331 20.371 21.302 19.9334C21.6708 19.4958 21.9068 18.9618 21.982 18.3945C22.0573 17.8272 21.9687 17.2501 21.7267 16.7315C21.4847 16.2129 21.0994 15.7743 20.6163 15.4675C20.1331 15.1607 19.5723 14.9985 19 15ZM19 20C18.6045 20 18.2178 19.8827 17.8889 19.6629C17.56 19.4432 17.3036 19.1308 17.1523 18.7654C17.0009 18.3999 16.9613 17.9978 17.0385 17.6098C17.1156 17.2219 17.3061 16.8655 17.5858 16.5858C17.8655 16.3061 18.2219 16.1156 18.6099 16.0384C18.9978 15.9613 19.3999 16.0009 19.7654 16.1522C20.1309 16.3036 20.4432 16.56 20.663 16.8889C20.8827 17.2178 21 17.6044 21 18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0392 19.7893 19.5305 20 19 20Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                            <span
                              style={{
                                boxSizing: "border-box",
                                display: "flex",
                                height: "100%",
                                position: "relative",
                              }}
                            >
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px",
                                  maxWidth: "96px",
                                  fontSize: "11px",
                                  lineHeight: "14px",
                                  fontWeight: 700,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                Voyager
                              </span>
                            </span>
                          </div>
                        </a>
                        <button
                          tabIndex={0}
                          type="button"
                          aria-controls="navBar-panelContent-0"
                          aria-expanded="false"
                          aria-label="Menu Voyager"
                          style={{
                            boxSizing: "border-box",
                            appearance: "button",
                            textTransform: "none",
                            overflow: "hidden",
                            fontFamily: "Avenir",
                            fontSize: "24px",
                            lineHeight: "27.6px",
                            margin: "-1px",
                            border: "0px none rgb(243, 243, 244)",
                            clip: "rect(0px, 0px, 0px, 0px)",
                            height: "1px",
                            padding: "0px",
                            position: "absolute",
                            whiteSpace: "nowrap",
                            width: "1px",
                            display: "flex",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            outline: "rgb(243, 243, 244) none 0px",
                            cursor: "pointer",
                            userSelect: "none",
                            verticalAlign: "middle",
                            textDecoration: "none solid rgb(243, 243, 244)",
                            textAlign: "center",
                            flex: "0 0 auto",
                            borderRadius: "50%",
                            color: "rgb(243, 243, 244)",
                            transition:
                              "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            fill: "rgb(141, 232, 254)",
                            right: "0px",
                            top: "50%",
                            transform: "none",
                          }}
                        >
                          <svg
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              boxSizing: "border-box",
                              height: "24px",
                              width: "1.5rem",
                            }}
                          >
                            <path
                              d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                              style={{ boxSizing: "border-box" }}
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </li>
                    <li style={{ boxSizing: "border-box" }}>
                      <div
                        style={{
                          boxSizing: "border-box",
                          height: "100%",
                          position: "relative",
                        }}
                      >
                        <a
                          aria-label="Billets"
                          href="/app/trips"
                          style={{
                            boxSizing: "border-box",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            margin: "0px",
                            fontSize: "13px",
                            lineHeight: "18px",
                            fontWeight: 700,
                            cursor: "pointer",
                            position: "relative",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "inline-flex",
                            boxShadow: "none",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            color: "rgb(243, 243, 244)",
                            padding: "0px",
                            height: "100%",
                            width: "100%",
                            textTransform: "none",
                            whiteSpace: "pre",
                            textDecoration: "none solid rgb(243, 243, 244)",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "24px",
                                width: "1.5rem",
                                fill: "rgb(243, 243, 244)",
                                flexShrink: 0,
                                margin: "8px 0px 4px",
                              }}
                            >
                              <path
                                d="M18 6H16V8H18V6Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M13 3V11H21V3H13ZM20 10H14V4H20V10Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M8 16H6V18H8V16Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M3 21H11V13H3V21ZM4 14H10V20H4V14Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M18 16H16V18H18V16Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M5 9H3V11H5V9Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M11 3H9V5H11V3Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M8 6H6V8H8V6Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M5 3H3V5H5V3Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M11 9H9V11H11V9Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M15 13H13V15H15V13Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M21 13H19V15H21V13Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M15 19H13V21H15V19Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                            <span
                              style={{
                                boxSizing: "border-box",
                                display: "flex",
                                height: "100%",
                                position: "relative",
                              }}
                            >
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px",
                                  maxWidth: "96px",
                                  fontSize: "11px",
                                  lineHeight: "14px",
                                  fontWeight: 700,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                Billets
                              </span>
                            </span>
                          </div>
                        </a>
                        <button
                          tabIndex={0}
                          type="button"
                          aria-controls="navBar-panelContent-1"
                          aria-expanded="false"
                          aria-label="Menu Billets"
                          style={{
                            boxSizing: "border-box",
                            appearance: "button",
                            textTransform: "none",
                            overflow: "hidden",
                            fontFamily: "Avenir",
                            fontSize: "24px",
                            lineHeight: "27.6px",
                            margin: "-1px",
                            border: "0px none rgb(243, 243, 244)",
                            clip: "rect(0px, 0px, 0px, 0px)",
                            height: "1px",
                            padding: "0px",
                            position: "absolute",
                            whiteSpace: "nowrap",
                            width: "1px",
                            display: "flex",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            outline: "rgb(243, 243, 244) none 0px",
                            cursor: "pointer",
                            userSelect: "none",
                            verticalAlign: "middle",
                            textDecoration: "none solid rgb(243, 243, 244)",
                            textAlign: "center",
                            flex: "0 0 auto",
                            borderRadius: "50%",
                            color: "rgb(243, 243, 244)",
                            transition:
                              "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            fill: "rgb(141, 232, 254)",
                            right: "0px",
                            top: "50%",
                            transform: "none",
                          }}
                        >
                          <svg
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              boxSizing: "border-box",
                              height: "24px",
                              width: "1.5rem",
                            }}
                          >
                            <path
                              d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                              style={{ boxSizing: "border-box" }}
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </li>
                    <li style={{ boxSizing: "border-box" }}>
                      <div
                        style={{
                          boxSizing: "border-box",
                          height: "100%",
                          position: "relative",
                        }}
                      >
                        <a
                          aria-label="Offres"
                          href="/app/catalogue"
                          aria-current="true"
                          style={{
                            boxSizing: "border-box",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            margin: "0px",
                            fontSize: "13px",
                            lineHeight: "18px",
                            fontWeight: 700,
                            cursor: "pointer",
                            position: "relative",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "inline-flex",
                            boxShadow: "none",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            color: "rgb(141, 232, 254)",
                            padding: "0px",
                            height: "100%",
                            width: "100%",
                            textTransform: "none",
                            whiteSpace: "pre",
                            textDecoration: "none solid rgb(141, 232, 254)",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "24px",
                                width: "1.5rem",
                                fill: "rgb(141, 232, 254)",
                                flexShrink: 0,
                                margin: "8px 0px 4px",
                              }}
                            >
                              <path
                                d="M20 2.99995H19.13V9.86376C19.1298 9.92559 19.109 9.98559 19.071 10.0344C19.033 10.0832 18.9799 10.1181 18.92 10.1335C18.8601 10.1551 18.7948 10.157 18.7337 10.1391C18.6725 10.1211 18.6187 10.0842 18.58 10.0336L16.93 7.90552L16.72 7.80561H16.47L16.37 7.85557L14.63 9.99364C14.5903 10.043 14.5365 10.0791 14.4757 10.0969C14.4149 10.1148 14.3501 10.1136 14.29 10.0935C14.2301 10.0781 14.177 10.0432 14.139 9.99443C14.101 9.94563 14.0802 9.88562 14.08 9.82379V3.16979L13.3 3.67934C12.7551 4.04506 12.3086 4.53916 12 5.11804C11.6544 4.46934 11.1364 3.92841 10.503 3.55473C9.86969 3.18105 9.14547 2.98909 8.41 2.99995H4C3.4798 2.99971 2.97998 3.20199 2.60658 3.56386C2.23319 3.92572 2.01561 4.4187 2 4.9382L2 16.9873C2.01815 17.5051 2.23685 17.9955 2.60997 18.3553C2.98309 18.715 3.48148 18.9159 4 18.9156H7.6C8.45713 18.9091 9.29534 19.1673 10 19.6549L10.64 20.1045L11.26 20.704C11.353 20.7976 11.4636 20.872 11.5854 20.9227C11.7073 20.9734 11.838 20.9995 11.97 20.9995C12.102 20.9995 12.2327 20.9734 12.3546 20.9227C12.4764 20.872 12.587 20.7976 12.68 20.704L13.27 20.1345L13.94 19.6549C14.6455 19.1492 15.4917 18.8767 16.36 18.8756H20C20.5119 18.8764 21.0046 18.681 21.3767 18.3297C21.7488 17.9785 21.9718 17.498 22 16.9873V4.99815C22 4.46819 21.7893 3.95994 21.4142 3.58521C21.0391 3.21047 20.5304 2.99995 20 2.99995ZM6.22 14.1199C6.12343 14.2593 5.98774 14.3671 5.83 14.4296C5.67031 14.4885 5.49821 14.5057 5.33 14.4796C5.16278 14.4428 5.00783 14.3636 4.88 14.2498C4.75317 14.1341 4.66869 13.9794 4.64 13.8102C4.5851 13.655 4.5851 13.4858 4.64 13.3306C4.72046 13.1818 4.84666 13.0627 5 12.9909C5.14667 12.8986 5.31667 12.8501 5.49 12.8511C5.719 12.8529 5.93947 12.9381 6.11 13.0908C6.26862 13.2503 6.35837 13.4655 6.36 13.6903C6.35566 13.844 6.30705 13.9931 6.22 14.1199ZM9.54 14.2098C9.39133 14.3634 9.19281 14.459 8.98 14.4796H8.11C7.99128 14.5044 7.86872 14.5044 7.75 14.4796C7.63529 14.4418 7.52972 14.3806 7.44 14.2998C7.34092 14.2174 7.26509 14.1107 7.22 13.99C7.16708 13.8828 7.13955 13.7649 7.13955 13.6453C7.13955 13.5258 7.16708 13.4079 7.22 13.3007C7.26509 13.18 7.34092 13.0733 7.44 12.9909C7.52972 12.9101 7.63529 12.8489 7.75 12.8111C7.86872 12.7863 7.99128 12.7863 8.11 12.8111H9C9.21281 12.8317 9.41133 12.9273 9.56 13.0809C9.70054 13.2353 9.77841 13.4366 9.77841 13.6453C9.77841 13.8541 9.70054 14.0554 9.56 14.2098H9.54ZM9.54 10.8728C9.39646 11.0222 9.20572 11.1175 9 11.1426H5.5C5.2867 11.1238 5.0876 11.0278 4.94 10.8728C4.79278 10.7218 4.71041 10.5192 4.71041 10.3084C4.71041 10.0975 4.79278 9.89496 4.94 9.74387C5.0876 9.58887 5.2867 9.49296 5.5 9.47411H9C9.21281 9.49471 9.41133 9.59034 9.56 9.74387C9.70054 9.89834 9.77841 10.0996 9.77841 10.3084C9.77841 10.5171 9.70054 10.7184 9.56 10.8728H9.54ZM9.54 7.52587C9.39646 7.67522 9.20572 7.7705 9 7.79562H5.5C5.2867 7.77677 5.0876 7.68086 4.94 7.52587C4.80234 7.38257 4.72072 7.19467 4.71 6.99634C4.70964 6.89256 4.72976 6.78972 4.76923 6.69371C4.8087 6.5977 4.86673 6.51042 4.94 6.43685C5.08659 6.27891 5.28558 6.17951 5.5 6.1571H9C9.21391 6.18124 9.41233 6.28036 9.56 6.43685C9.69439 6.59178 9.76575 6.79141 9.76 6.99634C9.74872 7.19263 9.67116 7.3793 9.54 7.52587ZM19.16 14.2098C19.0098 14.3613 18.8121 14.4565 18.6 14.4796H15.11C14.9002 14.4584 14.7051 14.3627 14.56 14.2098C14.4128 14.0587 14.3304 13.8562 14.3304 13.6453C14.3304 13.4345 14.4128 13.2319 14.56 13.0809C14.7051 12.928 14.9002 12.8323 15.11 12.8111H18.6C18.8121 12.8342 19.0098 12.9294 19.16 13.0809C19.3005 13.2353 19.3784 13.4366 19.3784 13.6453C19.3784 13.8541 19.3005 14.0554 19.16 14.2098Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                            <span
                              style={{
                                boxSizing: "border-box",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                                display: "flex",
                                height: "100%",
                                position: "relative",
                              }}
                            >
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px",
                                  maxWidth: "96px",
                                  fontSize: "11px",
                                  lineHeight: "14px",
                                  fontWeight: 700,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                Offres
                              </span>
                            </span>
                          </div>
                        </a>
                        <button
                          tabIndex={0}
                          type="button"
                          aria-controls="navBar-panelContent-2"
                          aria-expanded="false"
                          aria-label="Menu Offres"
                          style={{
                            boxSizing: "border-box",
                            appearance: "button",
                            textTransform: "none",
                            overflow: "hidden",
                            fontFamily: "Avenir",
                            fontSize: "24px",
                            lineHeight: "27.6px",
                            margin: "-1px",
                            border: "0px none rgb(243, 243, 244)",
                            clip: "rect(0px, 0px, 0px, 0px)",
                            height: "1px",
                            padding: "0px",
                            position: "absolute",
                            whiteSpace: "nowrap",
                            width: "1px",
                            display: "flex",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            outline: "rgb(243, 243, 244) none 0px",
                            cursor: "pointer",
                            userSelect: "none",
                            verticalAlign: "middle",
                            textDecoration: "none solid rgb(243, 243, 244)",
                            textAlign: "center",
                            flex: "0 0 auto",
                            borderRadius: "50%",
                            color: "rgb(243, 243, 244)",
                            transition:
                              "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            fill: "rgb(141, 232, 254)",
                            right: "0px",
                            top: "50%",
                            transform: "none",
                          }}
                        >
                          <svg
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              boxSizing: "border-box",
                              height: "24px",
                              width: "1.5rem",
                            }}
                          >
                            <path
                              d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                              style={{ boxSizing: "border-box" }}
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </li>
                    <li style={{ boxSizing: "border-box" }}>
                      <div
                        style={{
                          boxSizing: "border-box",
                          height: "100%",
                          position: "relative",
                        }}
                      >
                        <a
                          aria-label="Compte"
                          href="/app/account"
                          style={{
                            boxSizing: "border-box",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            margin: "0px",
                            fontSize: "13px",
                            lineHeight: "18px",
                            fontWeight: 700,
                            cursor: "pointer",
                            position: "relative",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "inline-flex",
                            boxShadow: "none",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            color: "rgb(243, 243, 244)",
                            padding: "0px",
                            height: "100%",
                            width: "100%",
                            textTransform: "none",
                            whiteSpace: "pre",
                            textDecoration: "none solid rgb(243, 243, 244)",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "24px",
                                width: "1.5rem",
                                fill: "rgb(243, 243, 244)",
                                flexShrink: 0,
                                margin: "8px 0px 4px",
                              }}
                            >
                              <path
                                d="M14.2507 10.0988C14.9317 9.65003 15.4628 9.00399 15.7743 8.24522C16.0859 7.48646 16.1634 6.65033 15.9968 5.84629C15.8476 5.03646 15.4591 4.29126 14.8826 3.70878C14.3061 3.12629 13.5686 2.73381 12.7671 2.58299C11.9711 2.41824 11.1444 2.49999 10.3952 2.81754C9.86342 3.0379 9.38334 3.36855 8.98599 3.78813C8.58863 4.2077 8.28284 4.70685 8.08837 5.25332C7.89391 5.79978 7.81511 6.3814 7.85706 6.96056C7.89901 7.53973 8.06078 8.10355 8.33191 8.61559C8.60304 9.12763 8.9775 9.57648 9.43109 9.93313C9.88467 10.2898 10.4073 10.5463 10.9651 10.6861C11.523 10.8259 12.1036 10.8458 12.6696 10.7447C13.2356 10.6435 13.7742 10.4235 14.2507 10.0988ZM13.6956 4.05147C14.2053 4.39619 14.6022 4.88597 14.8361 5.45877C15.1178 6.15045 15.1443 6.92136 14.9107 7.63109C14.6771 8.34082 14.1989 8.94216 13.5633 9.32559C12.9277 9.70903 12.177 9.84904 11.4478 9.72014C10.7186 9.59123 10.0594 9.20198 9.59045 8.62329C9.12146 8.04459 8.87378 7.31494 8.89254 6.56722C8.9113 5.81951 9.19524 5.10347 9.69264 4.54953C10.1901 3.99558 10.8678 3.64057 11.6026 3.54915C12.3373 3.45774 13.0801 3.636 13.6956 4.05147Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M7.39753 15.1161C8.30094 14.1869 9.45816 13.551 10.7212 13.2899C11.9842 13.0287 13.2956 13.1542 14.4877 13.6502C15.6798 14.1462 16.6983 14.9902 17.413 16.0743C18.1278 17.1583 18.5062 18.4332 18.4999 19.7357V20.9901C18.4973 21.1245 18.4433 21.2527 18.3493 21.3477C18.2552 21.4428 18.1283 21.4974 17.9953 21.5C17.8622 21.4974 17.7354 21.4428 17.6413 21.3477C17.5472 21.2527 17.4932 21.1245 17.4906 20.9901V19.7357C17.4906 18.2644 16.9121 16.8534 15.8824 15.813C14.8528 14.7726 13.4562 14.1881 12 14.1881C10.5438 14.1881 9.14721 14.7726 8.11751 15.813C7.08782 16.8534 6.50934 18.2644 6.50934 19.7357V20.9901C6.50676 21.1245 6.45276 21.2527 6.35867 21.3477C6.26459 21.4428 6.13772 21.4974 6.00469 21.5C5.9385 21.5008 5.87288 21.4876 5.81204 21.4612C5.7512 21.4349 5.69649 21.396 5.65143 21.347C5.60295 21.3015 5.56443 21.2462 5.53836 21.1847C5.51228 21.1233 5.49923 21.0569 5.50004 20.9901V19.7357C5.5014 18.0026 6.18392 16.341 7.39753 15.1161Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                            <span
                              style={{
                                boxSizing: "border-box",
                                display: "flex",
                                height: "100%",
                                position: "relative",
                              }}
                            >
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px",
                                  maxWidth: "96px",
                                  fontSize: "11px",
                                  lineHeight: "14px",
                                  fontWeight: 700,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                Compte
                              </span>
                            </span>
                          </div>
                        </a>
                        <button
                          tabIndex={0}
                          type="button"
                          aria-controls="navBar-panelContent-3"
                          aria-expanded="false"
                          aria-label="Menu Compte"
                          style={{
                            boxSizing: "border-box",
                            appearance: "button",
                            textTransform: "none",
                            overflow: "hidden",
                            fontFamily: "Avenir",
                            fontSize: "24px",
                            lineHeight: "27.6px",
                            margin: "-1px",
                            border: "0px none rgb(243, 243, 244)",
                            clip: "rect(0px, 0px, 0px, 0px)",
                            height: "1px",
                            padding: "0px",
                            position: "absolute",
                            whiteSpace: "nowrap",
                            width: "1px",
                            display: "flex",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            outline: "rgb(243, 243, 244) none 0px",
                            cursor: "pointer",
                            userSelect: "none",
                            verticalAlign: "middle",
                            textDecoration: "none solid rgb(243, 243, 244)",
                            textAlign: "center",
                            flex: "0 0 auto",
                            borderRadius: "50%",
                            color: "rgb(243, 243, 244)",
                            transition:
                              "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            fill: "rgb(141, 232, 254)",
                            right: "0px",
                            top: "50%",
                            transform: "none",
                          }}
                        >
                          <svg
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              boxSizing: "border-box",
                              height: "24px",
                              width: "1.5rem",
                            }}
                          >
                            <path
                              d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                              style={{ boxSizing: "border-box" }}
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </li>
                  </ul>
                </nav>
                <div
                  style={{
                    boxSizing: "border-box",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    display: "flex",
                    WebkitBoxPack: "end",
                    justifyContent: "flex-end",
                  }}
                ></div>
              </div>
            </div>
            <div
              style={{
                boxSizing: "border-box",
                backgroundColor: "rgb(141, 232, 254)",
                borderTopLeftRadius: "48px",
                borderTopRightRadius: "48px",
                bottom: "0px",
                content: '""',
                height: "2px",
                position: "absolute",
                width: "100%",
                left: "0px",
                opacity: 0,
                pointerEvents: "none",
              }}
            ></div>
          </div>
          <div
            aria-hidden="true"
            style={{
              opacity: 0,
              boxSizing: "border-box",
              position: "fixed",
              display: "flex",
              WebkitBoxAlign: "center",
              alignItems: "center",
              WebkitBoxPack: "center",
              justifyContent: "center",
              inset: "0px",
              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
              backgroundColor: "rgba(70, 77, 94, 0.7)",
              backdropFilter: "blur(2px)",
              zIndex: 1200,
            }}
          ></div>
        </div>
      </header>
    </div>
  );
};
